<template>
    <div class="home">
        <header class="sticky-header" :class="{ sticky: isSticky }">
        <img
          style="display: block;  margin-top: -8px"
          v-if="!isSticky"
          src="../../assets/changchenglogo.png"
          alt=""
        />
        <img
          style="display: block;  margin-top: -13px"
          v-if="isSticky"
          src="../../assets/changchenglogo2.png"
          alt=""
        />        
        <el-menu
          :class="{ stickymenu: isSticky }"
          :default-active="activeIndex"
          style="opacity: 1"
          class="el-menu-demo el-menu-vertical-demo"
         
          @select="handleSelect"
         
          text-color="white"
          active-text-color="white"
        
        >
        <!-- background-color="transparent" -->
          <el-menu-item index="1">首页</el-menu-item>
          <el-menu-item index="4">产业赋能</el-menu-item>
          <el-menu-item index="2">军单贷</el-menu-item>
          <el-menu-item index="8">票易融
          </el-menu-item>
          <el-menu-item index="3">军绿贷</el-menu-item>
         
          <el-menu-item index="5">关于</el-menu-item>
          <!-- <el-submenu
            index="5"
            style="color: black; font-size: 20px"
            :class="{ submenutitle: isSticky }"
           
          >
            <template slot="title" >关于</template>
            <el-menu-item index="5-1">新闻公告</el-menu-item>
            <div
              style="
                width: 80%;
                margin: 0 auto;
                background-color: #ccc;
                height: 0.5px;
                margin-top: 0px;
              "
            ></div>
            <el-menu-item index="5-2">企业简介</el-menu-item>
            <div
              style="
                width: 80%;
                margin: 0 auto;
                background-color: #ccc;
                height: 0.5px;
                margin-top: 0px;
              "
            ></div>
            <el-menu-item index="5-3">联系我们</el-menu-item>
            <div
              style="
                width: 80%;
                margin: 0 auto;
                background-color: #ccc;
                height: 0.5px;
                margin-top: 0px;
              "
            ></div>
            <el-menu-item index="5-4">常见问题</el-menu-item>
            <div
              style="
                width: 80%;
                margin: 0 auto;
                background-color: #ccc;
                height: 0.5px;
                margin-top: 0px;
              "
            ></div>
            <el-menu-item index="5-4">APP</el-menu-item>
          </el-submenu> -->
          <!-- <el-menu-item index="6"><a href="https://www.ele.me" target="_blank">注册</a></el-menu-item> -->
          <el-menu-item index="6" @click="zhuceclick()">注册</el-menu-item>
          <el-menu-item index="7" @click="loginclick()">登录</el-menu-item>
          <!-- <el-menu-item index="8"><a href="https://www.ele.me" target="_blank">APP</a></el-menu-item> -->
        </el-menu>
      </header>
        <div style="margin-top:4%;">
            <AboutView v-if="activeIndex == '5'" />
            <Military v-if="activeIndex == '2'" />
            <MilitaryGreen v-if="activeIndex == '3'" />
            <mastery v-if="activeIndex == '4'" />
        </div>
        <div style="width: 100%;height: 100%;background-color: #F1F4F8;padding-top: 10px;">

        <div style="display: flex;width: 60%;margin: 1% auto;">

        
        <!-- <img v-if="flag" class="backimg" src="../../assets/c_bei.png" alt=""> -->
        <div v-if="flag" style="width: 80%;background: white;overflow: scroll;padding-bottom: 200px;">
            <h2 style="padding-top: 30px;">{{ form.noticeTitle }}</h2>
            <el-divider></el-divider>
            <p style="font-size: 18px;color: rgba(61, 61, 61, 0.5);">{{ form.createTime }}</p>
            <el-divider></el-divider>
            <!-- <p style="text-align: left;text-indent: 2em;"> -->
            <!-- <div v-html="text"></div> -->


            <quill-editor  element-loading-text="数据加载中" v-loading="loading" ref="quillEditor"
                v-model="form.noticeContent"></quill-editor>
            <!-- <img style="z-index: 9999;" element-loading-text="图片加载中" v-loading="loading" :src="image" alt=""> -->
            <!-- </p> -->


            <!-- <p style="text-align: left;text-indent: 2em;margin-top: 25px;">
                该名单旨在围绕深化新一代信息技术与制造业融合发展，聚焦“数字领航”企业、两化（信息化与工业化）融合管理体系贯标、特色专业型工业互联网平台等方向，遴选一批试点示范项目，探索形成可复制、可推广的新业态和新模式，为制造业数字化转型注入新动能。
            </p>
            <div style="margin-top: 25px;">
                <img src="../../assets/20221117124170.png" alt="">
                <p>中信戴卡六号工厂获评全球铝车轮行业首家“灯塔工厂”</p>
            </div>
            <p style="text-align: left;text-indent: 2em;margin-top: 25px;">
                中信戴卡作为轻量化铝制汽车零部件智能制造领航企业成功入选。一直以来，中信戴卡积极抢抓数字化发展机遇，不断推动数智产品迭代和技术升级，以专业特色的工业互联网平台打造了全球铝车轮行业首家“灯塔工厂”，解决了多项技术难题。
 
            </p> -->
           
        </div>
        <ul style="width: 20%;margin-left: 15px;margin-top: -30px;">
            <li class="hov" style="width: 300px;height: 80px; border-radius: 10px; background-color: white;margin-top: 30px;padding: 20px;" v-for="(item,index) in datalistarry" :key="index" @click="handleClick(item)">
                <h4 style="text-align: left;">{{ item.noticeTitle }}</h4>
                <div style="display: flex;justify-content: space-between;">
                    <p style="text-align: left;margin-top: 20px;"> {{ item.createTime }}</p>
                <img style="width: 20px;height: 20px;margin-top: 20px;" src="../../assets/下载.png" alt="">
                </div>
            </li>
        </ul>
    </div>
        <div class="foter">
            <div style="width:800px;margin:50px auto;text-align: left;display: flex;">
                <img style="display: block;width: 88px;height: 88px;margin-top: 100px;margin-left:228px;"
                    src="../../assets/二维码 2.png" alt="">
                <div
                    style="margin-top: 100px;margin-left:83px;width: 2px;height: 88px;background: rgba(255, 255, 255, 0.2);">
                </div>
                <div style="width: 330px;margin-left: 30px;margin-top: 90px;">
                    <p style=" color: white;">
                        地址：北京市海淀区闵庄路3号玉泉慧谷5号楼
                    </p>
                    <p style="color: white">电话：010-62960259</p>
                    <p style="color: white">服务邮箱：ccgyljr@ccjr.freeqiye.com</p>
                </div>

            </div>
            <div
                style="display: flex;margin: 35px auto;flex-direction: row;align-items: center;justify-content: center;">
                <p style="color:#FFEDB2;margin-left:20px;">版权所有：国科智造</p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <p style="color:#FFEDB2;">ICP备案号：京ICP备10003784号</p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <p style="color:#FFEDB2;">京公网安备 33010802002218号 </p>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import hellow from '@/components/HelloWorld'
import AboutView from '@/components/about'
import Military from '@/components/Military'//军单贷
import MilitaryGreen from '@/components/MilitaryGreen'//军绿贷
import mastery from '@/components/mastery'//专精贷
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { noticelist, getfileupload } from "@/request/api"
export default {

    name: 'home',
    data() {
        return {
            activeIndex: '1',
            isSticky: true,
            flag: true,
            form: {},
            loading: false,
            image: "",
            text: "",
            getfileupload: "",
            datalistarry: []
        };
    },
    components: {
        AboutView,
        Military,
        MilitaryGreen,
        mastery,
        quillEditor
    },
    created() {
        this.datalist();
        this.getfileupload = getfileupload;
    },
    mounted() {

        this.form = JSON.parse(this.$route.query.item);

        this.startCountup()
        window.addEventListener('scroll', this.handleScroll);
    },

    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleClick(item) {
      window.open('http://www.cgwcrpt.com/#/aboutdetails?item=' + item.noticeId)
    //   window.open('http://192.168.1.18:28000/#/aboutdetails?item=' + item.noticeId)
      // var objJson =  encodeURIComponent(JSON.stringify(item));


      // window.open('http://localhost:8082/#/aboutdetails?item='+ item.noticeId)




    },
        datalist() {
            this.loading = true;


            noticelist().then(res => {
                if (res.code == 200) {
                    console.log(res.rows, 'res');
                    this.datalistarry = res.rows;
                    const element = res.rows.find(el => el.noticeId == this.form);
                    if (element) {
                        const RegEx = /(?<=(img src="))[^"]*?(?=")/gims
                        const img = element.noticeContent.match(RegEx);

                        console.log(element, 'element');

                        this.form = element;
                    }
                    this.loading = false;
                }
            }).catch(err => { })
        },
        unhoverImage() {
            this.flgabtn = true;// 鼠标移出时恢复原始图片
            this.flgabtn1 = false;// 鼠标移出时恢复原始图片
        },
        hoverImage() {
            this.flgabtn = false; // 鼠标悬停时更换图片
            this.flgabtn1 = true; // 鼠标悬停时更换图片
        },
        startCountup() {
            if (!this.timer) {
                this.timer = setInterval(() => {
                    if (this.currentNumber < this.targetNumber) {
                        this.currentNumber++;
                    } else {
                        // 达到目标数值后停止计时
                        clearInterval(this.timer);
                    }
                }, 100); // 每秒更新一次
            }
        },

        handleSelect(key, keyPath) {
            this.activeIndex = key;
            this.flag = false;
            if (this.activeIndex == '7') {
                this.$router.push('/login')
            }
            if (this.activeIndex == '6') {
                this.$router.push('/register')
            }
            if (key == '5-1' || key == '5-2' || key == '5-3' || key == '5-4') {
                this.activeIndex = 5;
            }
            if (key != '1') {
                this.isSticky = true;
                window.removeEventListener('scroll', this.handleScroll);
            }
            if (key == '1') {
                this.isSticky = false;
                this.$router.push('/')
                window.addEventListener('scroll', this.handleScroll);
            }
             if(key == '8'){
        // this.activeIndex = ""
        // window.open('https://rc-zslj.sxychain.com:8443/sp-inquiry');//测试
        window.open('https://htkj.sxychain.com/sp-inquiry');//正式

        
      }

        },
        handleScroll() {

            // this.isSticky = window.scrollY > 500;
            // const header = this.$el.querySelector('.sticky-header');
            // const scrollTop = document.documentElement.scrollTop;
            // const headerHeight = header.offsetHeight;

            // if (scrollTop >= headerHeight) {
            //     this.isSticky = true;
            // } else {
            //     this.isSticky = false;
            // }
        },
    }
}
</script>

<style scoped lang="scss">

body{

}
.backimg {
    display: block;
    position: absolute;
    // top: 0;
    width: 100%;
    height: 100%;
}

::v-deep .ql-editor {
    // text-align: center;
    // font-size: 15px !important;
}

::v-deep .ql-toolbar {
    display: none !important;
}

::v-deep .ql-container.ql-snow {
    border: none !important
}

::v-deep .el-submenu__title .el-submenu__icon-arrow::before {
    content: none !important;
}

.sticky-header.sticky {
    // background-color: rgb(84, 92, 100);
    background-color: white;
    color: #C49958;
    display: flex;
    width: 100%;
    height: 73px;
    // position: sticky;
    top: 0;
    opacity: 1;
    z-index: 10;
    box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
}

::v-deep .stickymenu {
    background-color: white;
    color: #C49958 !important;
    display: flex;
    width: 100%;
    position: sticky;
    top: 10px;
    opacity: 1;
    z-index: 10;
    text-align: center;

    .el-menu-item {

        background-color: white;
        color: #C49958 !important;
        display: flex;
        // width: 100%;
        position: sticky;
        top: 10px;
        opacity: 1;
        z-index: 10;
        text-align: center;

    }

    .submenutitle {
        font-size: 25px;

        .el-submenu__title {

            color: #C49958 !important;
            display: flex;
            width: 100%;
            position: sticky;
            top: 10px;
            opacity: 1;
            z-index: 10;
            text-align: center;

        }

    }


}

.sticky-header {
    width: 100%;
    height: 80px;
    // background-color: rgb(84, 92, 100);
    display: flex;
    position: fixed;
    top: 0;
    opacity: 0.7;
    transition: opacity 0.5s ease-in-out;
    color: white;
    z-index: 999;

}

// .sticky-header.sticky {
//     // background-color: rgb(84, 92, 100);
//     background-color: white;
//     color: #C49958;
//     display: flex;
//     width: 100%;
//     position: sticky;
//     top: 0;
//     opacity: 1;
//     z-index: 10;
// }




.jjimg {
    display: block;
    width: 1166px;
    height: 265px;
    position: relative;
    top: -80px;
    margin: 0 auto;
    transition: transform 0.3s ease;

    // box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.3);
}

.jjimg:hover {
    transform: scale(1.1);
}

.logo {
    display: inline-block;
    width: 50px;
    height: 50px;
    padding: 5px 0 0 40px;
}

.el-menu-demo {
    width: 693px;
    position: absolute;
    right: 50px;
    margin: 0 auto;
    display: flex;
    // margin-left: 23%;
    justify-content: space-around;
    // text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);

    border-bottom: none !important;

    .el-menu-item {
        font-size: 23px !important;
        // font-weight: bold;

    }

    .el-submenu {
        .el-submenu__title {
            font-size: 20px !important;
            // font-weight: bold;
        }
    }

}

::v-deep .el-menu-item:hover {
    background-color: transparent !important;

    // border-bottom: 2px solid #ccc !important;
}

/* 鼠标划过时显示下划线 */
::v-deep .el-menu-item:hover::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 2.5px;
    background-color: #ccc;
    /* 设置下划线的颜色 */
    transition: 100% 0.5s ease;
    /* 添加下划线宽度的过渡效果 */
}

/* 鼠标划过时，下划线从左到右滑动 */
::v-deep .el-menu-item:hover::after {
    width: 100%;
    /* 下划线宽度为 100% 时，表示滑动到最右边 */
}

.hov:hover{
    color: #53abf3 !important;
    cursor: pointer;

}


header {
  img {
    padding-top: 19px;
    padding-left: 146px;
  }
}

header .el-button {
  height: 80px;
  font-size: 15px;
  // line-height: 10px;
  margin-right: 20px;
  margin-top: 10px;
}
ul,
li {
    list-style: none
}
.foter {
    width: 100%;
    // bottom: 0px;
    height: 305px;
    background: #C49958;
    opacity: 0.8;
    // position: fixed;
    // bottom: 0;

    p {
        color: #7b5722;
        margin-top: 10px;
    }
}
</style>
<style lang="scss">
.el-menu--popup {
    width: 100px !important;
    min-width: 100px !important;
    margin-top: 10px !important;
    text-align: center;
    background-color: #3D3D3D !important;
    border-radius: 5px !important;
}

.el-submenu__title {
    font-size: 23px !important;
    // margin-top: 10px;
    // font-weight: bold;
}

.el-submenu__title:hover {
    border-bottom: 2.5px solid white !important;
    background-color: transparent !important;
}
</style>